// extracted by mini-css-extract-plugin
export var alignCenter = "_7x-d";
export var bannerShown = "_7x-6";
export var buttonContent = "_7x-0";
export var cardList = "_7x-1";
export var centerContent = "_7x-2";
export var chevron = "_7x-3";
export var closePanelButton = "_7x-k";
export var conversationContextContainer = "_7x-l";
export var conversationDetailContainer = "_7x-4";
export var detailWrapper = "_7x-7";
export var dropdownButton = "_7x-e";
export var dropdownTitle = "_7x-9";
export var fullHeight = "_7x-5";
export var hidden = "_7x-a";
export var icon = "_7x-b";
export var mergeSuggestionWrapper = "_7x-m";
export var panel = "_7x-i";
export var portalButtonsWrapper = "_7x-c";
export var right = "_7x-j";
export var tableSummaryContainer = "_7x-8";
export var tableSummaryHeader = "_7x-g";
export var threeDotsButton = "_7x-f";
export var wide = "_7x-h";